import React, { type ReactNode } from 'react';
import { NEWEST_FIRST, OLDEST_FIRST } from '@atlassian/jira-issue-shared-types';
import type { ActivitySortOrder } from '@atlassian/jira-issue-view-common-types/src/activity-item-type';
import type { FormatMessage } from '@atlassian/jira-shared-types';
import { ArrowDownIcon } from './assets/sorting-down-icon';
import { ArrowUpIcon } from './assets/sorting-up-icon';
import { messages } from './messages';

type SortOption = ActivitySortOrder & {
	icon: ReactNode;
};

export const getSortOptions = (formatMessage: FormatMessage): SortOption[] => [
	{
		key: NEWEST_FIRST,
		type: NEWEST_FIRST,
		name: formatMessage(messages.newestFirstLabel),
		icon: <ArrowDownIcon label="" />,
	},
	{
		key: OLDEST_FIRST,
		type: OLDEST_FIRST,
		name: formatMessage(messages.oldestFirstLabel),
		icon: <ArrowUpIcon label="" />,
	},
];
